"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLabel = void 0;

var styled_components_1 = __importStar(require("styled-components"));

var settings_1 = require("../../settings");

exports.StyledLabel = styled_components_1.default.label(function (_a) {
  var error = _a.error,
      onClick = _a.onClick;
  return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: block;\n    cursor: pointer;\n    font-weight: bold;\n    color: ", ";\n    margin-top: 1rem;\n\n    text-decoration: ", ";\n  "], ["\n    display: block;\n    cursor: pointer;\n    font-weight: bold;\n    color: ", ";\n    margin-top: 1rem;\n\n    text-decoration: ", ";\n  "])), error ? settings_1.settings.colours.error : settings_1.settings.colours.text, onClick ? 'underline' : 'none');
});
var templateObject_1;